import React from 'react';
import { renderToString } from 'react-dom/server';

import lineChartConfig from '../../../../components/Chart/LineChart';
import navigatorOptions from '../../../../components/Chart/ChartNavigator';
import { numberToHumanChart } from '../../../../utils/formatter';
import { getFallbackSubDateByGranularity } from '../../../../utils/helpers';
import { quarterLabel } from '../../utils';
import { formatQuarterYear } from '../../../../utils/date';
import { zooming, navigatorZoomEvent } from '../../../../utils/charts/options';

export const keyMetricsConfig = ({ chartStyleOverride, categories, overPeriod }) => {
  const animation = chartStyleOverride?.animation ?? {
    duration: 300,
  };

  return lineChartConfig({
    chartOptions: {
      type: 'column',
      spacing: [10, 0, 20, 0],
      height: 276,
      animation,
      zooming,
    },
    yAxis: {
      title: null,
      tickAmount: 6,
      startOnTick: true,
      labels: {
        reserveSpace: true,
        y: 5,
        style: {
          color: '#848EA1',
          fontSize: 12,
        },
        formatter() {
          return `${this.value}%`;
        },
      },
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
    },
    xAxisOptions: {
      type: 'category',
      tickLength: 0,
      lineWidth: 0,
      crosshair: false,
      minPadding: 0,
      labels: {
        autoRotation: null,
        formatter() {
          return categories[this.pos];
        },
        style: {
          color: '#848EA1',
          fontSize: 11,
        },
      },
      showFirstLabel: true,
      autoRotation: true,
      y: 26,
      events: navigatorZoomEvent,
    },
    tooltipOptions: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      borderRadius: 10,
      padding: 0,
      useHTML: true,
      outside: true,
      formatter() {
        const subDate = getFallbackSubDateByGranularity({
          isOverPeriod: overPeriod === 'period_over_period',
          granularity: 'quarterly',
          date: quarterLabel.convertToLastDay(this.x),
        });
        const prevQuarter = formatQuarterYear(subDate, {
          separator: quarterLabel.getSeparator(this.x),
        });

        return renderToString(
          <div
            style={{
              minWidth: '170px',
              borderRadius: '8px',
              border: '1px solid #E1E5EB',
              padding: '12px 16px',
              backgroundColor: '#fff',
              boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.08)',
            }}
          >
            <table className="table">
              <tr>
                <td className="text-left text-black text-12 p-l-0 p-b-0 pr-md">
                  {prevQuarter} vs {this.x}
                </td>
                <td
                  className="text-right  text-12 p-l-0 p-b-0"
                  style={{ color: '#5D6B85', lineHeight: '150%' }}
                >
                  <div className="text-bold text-black text-16">
                    <span>{numberToHumanChart(this.y)}%</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        );
      },
    },
    plotOptionsSeries: {
      animation,
    },
    plotOptionsSettings: {
      column: {
        minPointLength: 5,
        groupPadding: 0.05,
        borderRadius: 0,
      },
    },
    ...navigatorOptions({ enabled: false, height: 12, margin: 4 }),
  });
};
